import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../auth/AuthContext";
import Loader from "../../shared/Loader";

import { LogoutBlackIcon, CallendarBlackIcon, StoreWhiteIcon } from "../../../assets/icons";
import { useEffect, useState } from "react";
import { SelectLocalInfoDTO } from "../../../models/local/local.response";
import { localService } from "../../../services/localService";
import { useNotification } from "../../toster-notification/NotificationContext";
import { ToLocalDateString } from "../../../utils/dateFormater";


const SelectLocalPage: React.FC = () => {

    const [locals, setLocals] = useState<SelectLocalInfoDTO[]>([]);

    const [loading, setLoading] = useState<boolean>(false);

    const { logout, user } = useAuth();
    const { notify } = useNotification();
    const navigate = useNavigate();

    useEffect(() => {
        fetchLocals();
    }, [notify, user]);

    const fetchLocals = async () => {
        if (!user) {
            notify("error", "User not authenticated.");
            return;
        }

        setLoading(true);
        try {
            const response = await localService.getByUserId(user.id);

            if (response.data) {
                setLocals(response.data);
            }
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                notify("error", error.response.data.message || "Failed to fetch locals.");
            } else {
                notify("error", "Failed to fetch locals.");
            }
        } finally {
            setLoading(false);
        }
    };


    const handleLogout = () => {
        logout();
        navigate("/login");
    };

    const handleSelectLocal = (localId: string) => {
        navigate(`/settings/${localId}/dashboard`);
    }

    if(loading){
        return <Loader />;
    }

    return (
        <>
            <section className="select-local-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="select-local-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Izaberite lokaciju</h2>
                                <div className="text-block">
                                    Prijavljen kao: Admin Korisnik<br />
                                </div>
                            </div>
                            <div className="header-button-div">
                                <div className="button-secondary" onClick={handleLogout}>
                                    <img loading="lazy" src={LogoutBlackIcon} alt="" className="button-image" />
                                    <div>
                                        <strong>Odjavi se</strong>
                                        <br />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="select-local-list">

                            {locals.map((local) => (
                                <div className="select-local-div">
                                    <div className="select-local-bg-image-div">
                                        {local.backgroundImageUrl && (
                                            <img loading="lazy" src={local.backgroundImageUrl + "@ul.webp"} alt="" className="select-local-bg-image" />
                                        )}
                                    </div>
                                    <div className="select-local-info-block">
                                        <div className="select-local-info-header">
                                            <div className="select-local-image-div">
                                                {local.logoImageUrl && (
                                                    <img loading="lazy" src={local.logoImageUrl + "@ul.webp"} alt="" className="select-local-image" />
                                                )}
                                            </div>
                                            <div className="select-local-info-div">
                                                <div className="select-local-name">{local.name}</div>
                                                <div className="select-local-description">{local.description}</div>
                                            </div>
                                        </div>
                                        <div className="select-local-plan-expired-div">
                                            <img loading="lazy" src={CallendarBlackIcon} alt="" className="image-10" />
                                            <div className="select-local-plan-sxpired">Članarina do {ToLocalDateString(local.planEndAt.toString())}</div>
                                        </div>
                                        <div className="button-primary select-local" onClick={() => handleSelectLocal(local.id)}>
                                            <img loading="lazy" src={StoreWhiteIcon} alt="" className="button-image" />
                                            <div>
                                                <strong>Upravljaj</strong>
                                                <br />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            ))}

                        </div>
                    </div>
                </div>
            </section>
        </>
    );

};

export default SelectLocalPage;